import Vue from 'vue'
import Vuex from 'vuex'
import mqtt from 'mqtt'
import { MQTT_SERVICE, MQTT_USERNAME } from '../components/robot/sysconstant'
import router from '../router'
import cookies from 'vue-cookies'



//挂载Vuex
Vue.use(Vuex)
//const mqttClient = JSON.parse(localStorage.getItem("mqttClient"))
const mqttClient = null;
//创建VueX对象   
var that=this
const store = new Vuex.Store({
    state:{
        mqttClient
    },
    mutations: {
        changeMqtt(state, mqtt) {
            state.mqttClient = mqtt
        },
        initMqtt(state, mqtt) {
            state.mqttClient = mqtt
            console.log("清除Mqtt链接:="+mqtt)
        }
    },
    actions: {
        mqttServer({commit}) {
            commit('initMqtt', null)
            //var dateStr= (new Date()).getTime().toString()
            var dateStr= Number(Math.random().toString().substr(3) + Date.now()).toString(36);
            console.log(dateStr)
            //定义随机clientId
            var _clientId="web"+dateStr;
            //var password= window.sessionStorage.getItem("sign")     
            var password=  cookies.get("sign")
            const mqttOptions = {
                clientId: _clientId,
                username: MQTT_USERNAME,
                password: password,
                clean: true,
                connectTimeout: 30000, // 超时时间
                reconnectPeriod: 30000, // 重连时间间隔
            }
            console.log("正在连接.............")
            var client = mqtt.connect(MQTT_SERVICE, mqttOptions)
            var count=0
            client.on('connect', function() {
                console.log("connect..连接成功")
                //localStorage.setItem("mqttClient", JSON.stringify(client));
                commit('changeMqtt', client)
            })
            // 断开发起重连
            client.on('reconnect', (error) => {
                count++
                console.log('正在重连...', error)
                if(count==10){
                    return router.push('/login') 
                }
            })
           //监控错误
           client.on('error', error => {
            commit('changeMqtt', null)
            console.log('Connection failed', error)
        })
        }
   }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js